module.exports = __webpack_public_path__ + "static/media/toool-dark-logo.3067ea9c.png";